import React from 'react';
import { Link } from 'react-router-dom';

import Cover from 'components/Cover';

const Hero = ({ name, category, banner, rules, backButton = false }) => {
  return (
    <article className="hero">
      <Cover src={banner} />
      <div className="hero__content">
        <span className="hero__category">{category}</span>
        <h2 className="hero__title">{name}</h2>
      </div>

      <footer className="hero__extras">
        {backButton && (
          <Link to="/" className="button--small">
            Voltar
          </Link>
        )}
        {rules && (
          <a href={rules} target="_blank" rel="noopener noreferrer" className="button--small">
            Regulamento
          </a>
        )}
      </footer>
    </article>
  );
};

export default Hero;
